import './index.scss';
import './assets/scripts/App';




// WEBPACK FOOTER //
// ./src/index.js